import React from 'react';
import { useApp } from '../context/AppContext';

// A thin bar across the top when the phone has no signal.
//
// Worth having because the app now keeps working offline — jobs and threads
// still open from cache — and an app that looks entirely normal while showing
// data from twenty minutes ago is how someone drives to the wrong address.
// Saying "offline" is the difference between cached and wrong.
export default function OfflineBar() {
  const { isOffline } = useApp();
  if (!isOffline) return null;

  return (
    <div className="topbar topbar-offline" role="status">
      <span>No signal — showing what was last loaded. Messages will not send.</span>
    </div>
  );
}
